export const messages =  [
    {
        id:1,
        name:"Jimmy",
        avatar:"/images/avatars/Vector-10.png",
        date:"08:32 AM",
        messages:[
            "Let's make some design wonders happen today! 🎨✨",
        ],
        images:[
            {type:'image', path:"/images/shared/camera.jpg", size:''},
            {type:'image', path:"/images/shared/car.jpg", size:''},
        ],
        reactions:[
            {emoji:'🔥', count:'5'},
            {emoji:'👏', count:'4'},
        ]
    },
    {
        id:2,
        name:"Maria",
        avatar:"/images/avatars/Vector-9.png",
        date:"08:32 AM",
        messages:[
            "Good morning, A! Thanks for the positive vibes.",
            "Sure, @Richard Wuand @Jimmy contributions are invaluable. 🙌🏻💯",

        ],
    },
    {
        id:3,
        name:"Richard Wu",
        avatar:"/images/avatars/Vector-11.png",
        date:"10:12 PM",
        messages:[
            "Let's do this! 💪🚀",
            {type:'audio', path:'./', duration:'01:21'},
            'Ready to rock the development side and bring those designs to life.',
        ],
    },
    {
        id:4,
        name:"You",
        me:true,
        avatar:"/images/avatars/Vector-12.png",
        date:"10:40 PM",
        messages:[
            "That means a lot, D! It's the synergy",
            "Couldn't ask for a better team! 🚀💖",
        ],
    },
    {
        id:5,
        name:"Luffy de King",
        avatar:"/images/avatars/Vector-13.png",
        date:"10:52 PM",
        messages:[
            "Thanks for the feedbacks, Ricardo!",
            "And you working hard Jimmy"
         ],
    },
]

export const neonMessages = [
  {
    sort:0,
    deleted:true,
    user:{
      name:"Shaggy",
      avatar:"/images/avatars/Vector-11.png",
      foreground:'#ed438f',
    },
    date:"2023-06-21T12:00:00-10:30",
    messages:[
        "Ok, then!",
    ],
 },
{
    sort:1,
    user:{
      name:"John Doe",
      avatar:"/images/avatars/Vector-11.png",
      foreground:'#34a853',
    },
    date:"2023-06-21T12:00:00-10:30",
    messages:[
        "👋 Hey folks, I stumbled upon this cool CSS trick. 😆Check it out! It could add a delightful touch to our designs 👌👌👌",
    ],
},
{
  sort:2,
  user:{
    name:"Katy",
    avatar:"/images/avatars/Vector-15.png",
    foreground:'#ed438f',
  },
  date:"2023-06-22T12:00:00-10:30",
  messages:[
      "Hi @Kate We're lucky to have them.",
  ],
},
{
  sort:3,
  user:{
    name:"Jane",
    avatar:"/images/avatars/Vector-14.png",
    foreground:'#f24e1e',
  },
  date:"2023-07-17T12:00:00-08:30",
  messages:[
      "@Micheal Wow pretty good! Our team lead has been an incredible mentor, provsorting valuable insights and helping us navigate complex projects.",
  ],
  reactions:[
      {emoji:'❤️', count:'55', voted:false},
      {emoji:'👍', count:'14', voted:false},
      {emoji:'🔥', count:'23', voted:false},
  ],
},
{
  sort:4,
  user:{
    name:"Design Team",
    avatar:"/images/avatars/Vector-1.png",
    foreground:'#fdad00',
  },
  date:"2023-07-18T12:00:00-03:15",
  messages:[
      {type:'audio',name:'Apocalyptica - Path', path:"/path.mp4", date:'5:02'},
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. A minima harum sapiente cupsortitate corporis maiores, deleniti nemo impedit sequi explicabo excepturi, necessitatibus exercitationem incsortunt quisquam porro laborum, nobis magnam deserunt.",
      {type:'file', path:"/file_name_example.pdf", size:'15MB', date:'21.08.2023'},
      {type:'file', path:"/file_name_example.pdf", size:'15MB', date:'21.08.2023'},
  ],
},
{
  sort:5,
  user:{
    name:"Design Team",
    avatar:"/images/avatars/Vector-12.png",
    foreground:'#3b82f6',
  },
  date:"2023-07-18T12:00:00-10:03",
  messages:[
     "Consectetur adipisicing elit. A minima harum sapiente cupsortitate exercitationem incsortunt quisquam porro laborum, nobis magnam deserunt."
  ],
  reactions:[
      {emoji:'❤️', count:'55', voted:false},
      {emoji:'👍', count:'14', voted:false},
      {emoji:'🔥', count:'23', voted:false},
  ],
},
{
  sort:6,
  user:{
    name:"Design Team",
    avatar:"/images/avatars/Vector-13.png",
    foreground:'#f24e1e',
  },
  date:"2023-07-18T12:00:00-11:03",
  messages:[
      "A minima harum nobis magnam deserunt."
  ],
  images:[
      { type:'image', path:"/images/shared/Rectangle 6.png" },
      { type:'image', path:"/images/shared/Rectangle 7.png" },
      { type:'image', path:"/images/shared/Rectangle 8.png" },
      { type:'image', path:"/images/shared/Rectangle 5.png" },
  ],
} 
]

export const teamMessages = [
 
    {
        id:1,
        name:"Jesse",
        avatar:"/images/avatars/Vector-14.png",
        foreground:'#a162ba',
        date:"2023-06-21T12:00:00-10:30",
        messages:[
            "It's a feature, not a bug. Also https://github.com/ 🌎 Explicabo adipisci consectetur pariatur ad et odit facilis. @Gamer "
        ],

    },
    
    {
        id:900,
        event:'ADMIN LOGGED IN',
    },
    {
        id:901,
        event:'ADMIN LOGGED OUT',
    },
    

    {
        id:2,
        name:"Rosy",
        avatar:"/images/avatars/Vector-9.png",
        foreground:'#a162ba',
        date:"2023-06-22T12:00:00-10:30",
        files:[
            {type:'file', path:"filename.pdf", size:'15MB', date:'21.08.2023'},
            {type:'file', path:"filename.pdf", size:'15MB', date:'21.08.2023'},
            {type:'file', path:"filename.pdf", size:'15MB', date:'21.08.2023'},
        ],
         
    },
    {
        id:3,
        name:"Gamer",
        avatar:"/images/avatars/Vector-12.png",
        foreground:'#f24e1e',
        date:"2023-07-17T12:00:00-08:30",
        messages:[
            "@Mike Will there be example for producer? 👑 Explicabo adispisci consectetur parlatur ad et odit facilis fugit reiciendis autem a eos placeat nulla ex fuga!  https://openai.com/blog/chatgpt "
        ],
        preview:{
            title:'Introducing ChatGPT',
            description:'We’ve trained a model called ChatGPT which interacts in a conversational way. The dialogue format makes it possible for ChatGPT to answer followup questions, admit its mistakes, challenge incorrect premises, and reject inappropriate requests.',
            logo:'/images/brands/chatgpt.svg',
        }
    },
    {
        id:4,
        name:"Sparkle",
        avatar:"/images/avatars/Vector-13.png",
        foreground:'#e68228',
        date:"2023-07-18T12:00:00-03:15",
        messages:[
             "use prettier lol \n VSCode!",
        ],
        reactions:[
            {emoji:'🔥', count:'233', voted:false},
            {emoji:'👏', count:'114', voted:true},
        ],
    },
    {
        id:5,
        name:"Pearl",
        avatar:"/images/avatars/Vector-15.png",
        foreground:'#2ecc71',
        date:"2023-07-18T12:00:00-10:03",
        messages:[
            "he meant messey logic"
        ],
    },
 
    
]


/*** Messenger Conversations **/

export const messengerMessages1 =  [
    {
        id:1,
        name:"Jimmy",
        avatar:"/images/avatars/Vector-10.png",
        date:"08:32 AM",
        messages:[
            "Let's make some design wonders happen today! 🎨✨",
        ],
        images:[
            {type:'image', path:"/images/shared/camera.jpg", size:''},
            {type:'image', path:"/images/shared/car.jpg", size:''},
        ],
        reactions:[
            {emoji:'🔥', count:'5'},
            {emoji:'👏', count:'4'},
        ]
    },
]
export const messengerMessages2 = [
    {
        id:2,
        name:"Maria",
        avatar:"/images/avatars/Vector-9.png",
        date:"08:32 AM",
        messages:[
            "Good morning, Alex! Thanks for the positive vibes.",
            "Sure, @Richard Wuand @Jimmy contributions are invaluable. 🙌🏻💯",

        ],
    },
]
export const messengerMessages3 = [
    {
        id:3,
        name:"Richard Wu",
        avatar:"/images/avatars/Vector-11.png",
        date:"10:12 PM",
        messages:[
            "Let's do this! 💪🚀",
            {type:'audio', path:'./', duration:'01:21'},
            'Ready to rock the development side and bring those designs to life.',
        ],
    },
]
export const messengerMessages4 = [
    {
        id:4,
        name:"You",
        me:true,
        avatar:"/images/avatars/Vector-12.png",
        date:"10:40 PM",
        messages:[
            "That means a lot, D! It's the synergy",
            "Couldn't ask for a better team! 🚀💖",
        ],
    },
]
export const messengerMessages5 = [
    {
        id:5,
        name:"Luffy de King",
        avatar:"/images/avatars/Vector-13.png",
        date:"10:52 PM",
        messages:[
            "Thanks for the feedbacks, Ricardo!",
            "And you working hard Jimmy"
         ],
    },
]
export const messengerMessages6 = []
export const messengerMessages7 = []
export const messengerMessages8 = []
export const messengerMessages9 = []


/*** Team Conversations **/

export const teamMessages1 = [
 
    {
        id:1,
        name:"Jesse",
        avatar:"/images/avatars/Vector-14.png",
        foreground:'#a162ba',
        date:"2023-06-21T12:00:00-10:30",
        messages:[
            "It's a feature, not a bug. Also https://github.com/ 🌎 Explicabo adipisci consectetur pariatur ad et odit facilis."
        ],

    },
    
  
 
    
]
export const teamMessages2 = [
    {
        id:900,
        event:'ADMIN LOGGED IN',
    },
    {
        id:901,
        event:'ADMIN LOGGED OUT',
    },
    {
        id:2,
        name:"Rosy",
        avatar:"/images/avatars/Vector-9.png",
        foreground:'#a162ba',
        date:"2023-06-22T12:00:00-10:30",
        files:[
            {type:'file', path:"/filename.pdf", size:'15MB', date:'21.08.2023'},
            {type:'file', path:"/filename.pdf", size:'15MB', date:'21.08.2023'},
            {type:'file', path:"/filename.pdf", size:'15MB', date:'21.08.2023'},
        ],
         
    },
]
export const teamMessages3 = [
    
    {
        id:3,
        name:"Gamer",
        avatar:"/images/avatars/Vector-12.png",
        foreground:'#f24e1e',
        date:"2023-07-17T12:00:00-08:30",
        messages:[
            "Will there be example for producer? 👑 Explicabo https://openai.com/blog/chatgpt adispisci consectetur parlatur ad et odit facilis fugit reiciendis autem a eos placeat nulla ex fuga!"
        ],
        preview:{
            title:'Introducing ChatGPT',
            description:'We’ve trained a model called ChatGPT which interacts in a conversational way. The dialogue format makes it possible for ChatGPT to answer followup questions, admit its mistakes, challenge incorrect premises, and reject inappropriate requests.',
            logo:'/images/brands/chatgpt.svg',
        }
    },
  
]
export const teamMessages4 = [
    {
        id:4,
        name:"Sparkle",
        avatar:"/images/avatars/Vector-13.png",
        foreground:'#e68228',
        date:"2023-07-18T12:00:00-03:15",
        messages:[
             "use prettier lol \n VSCode!",
        ],
        reactions:[
            {emoji:'🔥', count:'233', voted:false},
            {emoji:'👏', count:'114', voted:true},
        ],
    },
]
export const teamMessages5 = [
    {
        id:5,
        name:"Pearl",
        avatar:"/images/avatars/Vector-15.png",
        foreground:'#2ecc71',
        date:"2023-07-18T12:00:00-10:03",
        messages:[
            "he meant messey logic"
        ],
    },
]
export const teamMessages6 = [
    {
        id:5,
        name:"Sparkle",
        avatar:"/images/avatars/Vector-14.png",
        foreground:'#2ecc71',
        date:"2023-07-18T12:00:00-10:03",
        messages:[
            "Shortly, all around the world",
            "Isn't it?"
        ],
    },
]
export const teamMessages7 = []
export const teamMessages8 = []
export const teamMessages9 = []

 
/*** Neon Conversations **/

export const neonMessages1 = [
    {
        deleted:true,
    },
    {
        sort:0,
         user:{
        name:"Shaggy",
        avatar:"/images/avatars/Vector-11.png",
        foreground:'#ed438f',
        },
        date:"2023-06-21T12:00:00-10:30",
        messages:[
            "Ok, then!",
        ],
    }
]
export const neonMessages2 = [
    {
        sort:1,
        user:{
          name:"John Doe",
          avatar:"/images/avatars/Vector-11.png",
          foreground:'#34a853',
        },
        date:"2023-06-21T12:00:00-10:30",
        messages:[
            "👋 Hey folks, I stumbled upon this cool CSS trick. 😆Check it out! It could add a delightful touch to our designs 👌👌👌",
        ],
    },
]
export const neonMessages3 = [
    {
        sort:2,
        user:{
          name:"Katy",
          avatar:"/images/avatars/Vector-15.png",
          foreground:'#ed438f',
        },
        date:"2023-06-22T12:00:00-10:30",
        messages:[
            "Hi @Kate We're lucky to have them.",
        ],
      },
]
export const neonMessages4 = [
    {
        sort:3,
        user:{
          name:"Jane",
          avatar:"/images/avatars/Vector-14.png",
          foreground:'#f24e1e',
        },
        date:"2023-07-17T12:00:00-08:30",
        messages:[
            "@Micheal Wow pretty good! Our team lead has been an incredible mentor, provsorting valuable insights and helping us navigate complex projects.",
        ],
        reactions:[
            {emoji:'❤️', count:'55', voted:false},
            {emoji:'👍', count:'14', voted:false},
            {emoji:'🔥', count:'23', voted:false},
        ],
      },
]
export const neonMessages5 = [
    {
        sort:4,
        user:{
          name:"Design Team",
          avatar:"/images/avatars/Vector-1.png",
          foreground:'#fdad00',
        },
        date:"2023-07-18T12:00:00-03:15",
        messages:[
            {type:'audio',name:'Apocalyptica - Path', path:"/path.mp4", date:'5:02'},
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. A minima harum sapiente cupsortitate corporis maiores, deleniti nemo impedit sequi explicabo excepturi, necessitatibus exercitationem incsortunt quisquam porro laborum, nobis magnam deserunt.",
            {type:'file', path:"/file_name_example.pdf", size:'15MB', date:'21.08.2023'},
            {type:'file', path:"/file_name_example.pdf", size:'15MB', date:'21.08.2023'},
        ],
      },
]
export const neonMessages6 = [
    {
        sort:5,
        user:{
          name:"Design Team",
          avatar:"/images/avatars/Vector-12.png",
          foreground:'#3b82f6',
        },
        date:"2023-07-18T12:00:00-10:03",
        messages:[
           "Consectetur adipisicing elit. A minima harum sapiente cupsortitate exercitationem incsortunt quisquam porro laborum, nobis magnam deserunt."
        ],
        reactions:[
            {emoji:'❤️', count:'55', voted:false},
            {emoji:'👍', count:'14', voted:false},
            {emoji:'🔥', count:'23', voted:false},
        ],
      },
]
export const neonMessages7 = [
    {
        sort:6,
        user:{
          name:"Design Team",
          avatar:"/images/avatars/Vector-13.png",
          foreground:'#f24e1e',
        },
        date:"2023-07-18T12:00:00-11:03",
        messages:[
            "A minima harum nobis magnam deserunt."
        ],
        images:[
            { type:'image', path:"/images/shared/Rectangle 6.png" },
            { type:'image', path:"/images/shared/Rectangle 7.png" },
            { type:'image', path:"/images/shared/Rectangle 8.png" },
            { type:'image', path:"/images/shared/Rectangle 5.png" },
        ],
      } 
]